import axios from "axios";
import { deletePrinterError } from "@/collections/printerErrors";

export default {
  methods: {
    printersAreActive() {
      return (
        this.settings.activePrinters !== undefined &&
        this.settings.activePrinters === true
      );
    },
    makePrinterCall(orders, table, printers = [], groupId = "") {
      if (!this.printersAreActive) {
        this.showErrorMessage("Las impresoras no estan activas");
        return;
      }

      const data = {
        id: table,
        table: {
          to_share: [],
          seconds: [],
          all: []
        },
        general_comment: "MARCHAR SEGUNDOS",
        time: this.formatDateTime(orders[0].time)
      };

      // Make API call to send to selectedPrinters
      this.selectedPrinters.forEach(printerUrl => {
        let printerName = "";
        if (printers && printers.length) {
          let printer = printers.find(p => p.url === printerUrl);
          printerName = printer ? printer.name : "";
        }
        this.postPrinterRequest(printerUrl, data, printerName, groupId);
      });
    },
    postPrinterRequest(printerUrl, data, printerName = "", groupId = "") {
      const id = this.uuidv4();

      axios
        .post(printerUrl, data)
        .then(async response => {
          if (response.status === 200 && response.data.result === true) {
            this.showSuccessMessage("Imprimiendo");
            this.setPrinterInfo(id, printerUrl, printerName, data, groupId);
          } else {
            this.showErrorMessage("Error de impresión");
            this.setPrinterError(id, printerUrl, printerName, data, groupId);
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(async () => {
          this.showErrorMessage("Error en la petición de impresión");
          this.setPrinterError(id, printerUrl, printerName, data, groupId);
        });
    },
    buildPrinterData(array, tableQR, comments, ordersGroupeByTableQR) {
      // filter orders
      let otherOrders = array.filter(item => {
        return !item.canBeShared && !item.canBeMainCourse;
      });

      let mainCourseOrders =
        this.arrayGroupBy(array, "canBeMainCourse").true || [];
      mainCourseOrders = mainCourseOrders.filter(item => {
        return !item.canBeShared || item.index > 0;
      });

      let toShareOrders = this.arrayGroupBy(array, "canBeShared").true || [];
      toShareOrders = toShareOrders.filter(item => {
        return item.index ? item.index === 0 : item;
      });
      let _orders = {
        to_share: toShareOrders,
        seconds: mainCourseOrders,
        all: otherOrders
      };

      return {
        id: tableQR,
        table: _orders,
        general_comment: comments.join(", "),
        time: this.formatDateTime(ordersGroupeByTableQR[0].time)
      };
    },
    reprintErroredItem(id, printerUrl, data) {
      data.time = this.formatDateTime2(data.time);

      axios
        .post(printerUrl, data)
        .then(async response => {
          if (response.status === 200 && response.data.result === true) {
            this.showSuccessMessage("Imprimiendo");
            // delete from collection
            this.deletePrinterError(id);
          } else {
            this.showErrorMessage("Error de impresión");
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(async error => {
          this.showErrorMessage("Error en la petición de Re-impresión");
        });
    },
    async deletePrinterError(id) {
      deletePrinterError(id);
    }
  }
};
